import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRealestateNetYearlyIncome } from "./netYearlyIncome";
import { calculateRentYearly } from "./rent";

export const calculateRealestateOriginStateCurrency = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const originStateTax = userProduct?.sourceStateFee || 0;
  const originStateType = userProduct?.sourceStateFeeFromRevenue;

  const netYearlyIncome = calculateRealestateNetYearlyIncome(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const totalIncome = calculateRentYearly(userProduct);

  return originStateType
    ? (totalIncome * originStateTax) / 100
    : (netYearlyIncome * originStateTax) / 100;
};
